/**
 * Rows the study's dictionary has and the uploaded file does not (2026-09-17).
 *
 * Jim's decision: LIST them each time and let the person decide. So the ticks
 * start empty and the apply is told exactly what was ticked — keeping is the
 * default, because a row missing from a file is as likely to be a filtered
 * export as a retired variable.
 *
 * Pure; shapes mirror functions/src/dataDictionary/droppedEntries.ts.
 */

export interface DroppedEntry {
  docId: string;
  formCode: string;
  formName: string;
  fieldName: string;
  fieldLabel: string;
  /** True while a question on a form still points at this row. */
  hasQuestion: boolean;
}

export function droppedEntriesText(dropped: DroppedEntry[]): { headline: string; body: string } | null {
  const n = dropped?.length ?? 0;
  if (n === 0) return null;
  return {
    headline: n === 1
      ? "1 row in this study's dictionary is not in this file."
      : `${n} rows in this study's dictionary are not in this file.`,
    body: 'They are kept unless you tick them. Ticking one removes it from the dictionary; '
      + 'the question on the form is not touched.',
  };
}

export function droppedEntryLine(d: DroppedEntry): string {
  const base = `${d.formName || d.formCode} · ${d.fieldName} — ${d.fieldLabel}`;
  return d.hasQuestion ? `${base} (a question on the form still uses this row)` : base;
}

/** Nothing ticked: keeping a row is what happens when the person says nothing. */
export function initialDroppedTicks(_dropped: DroppedEntry[]): Record<string, boolean> {
  return {};
}

/** Always a list, so the apply hears "none" rather than hearing nothing. */
export function tickedDroppedIds(ticks: Record<string, boolean>): string[] {
  return Object.entries(ticks || {}).filter(([, on]) => on).map(([id]) => id);
}
